import React, { useEffect, useState } from "react";
import {
  convertRupeesToWords,
  roundOffCost,
  roundOffCostWithoutRupee,
} from "../../../Components/Functions/amt.fun";
import KryzenTop from "../PdfQuotationsTables/kryzen_Top";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

const QuotationAmounts = ({ allQData }) => {
  const [scope, setScope] = useState("");
  const [iotUnit, setIOTUnit] = useState(1);
  let s = 0;

  useEffect(() => {
    if (allQData?.input_info?.quotationType === "hydroponics only") {
      setScope("Hydroponic");
    } else if (
      allQData?.input_info?.quotationType === "nvph" ||
      allQData?.input_info?.quotationType === "fanpad" ||
      allQData?.input_info?.quotationType === "nethouse"
    ) {
      setScope("CEA");
    } else {
      setScope("CEA + Hydroponic");
    }

    let iotUnit = 0;
    if (allQData?.input_info?.a_FramePercent > 0) {
      iotUnit++;
    }
    if (allQData?.input_info?.flatBedPercent > 0) {
      iotUnit++;
    }
    if (allQData?.input_info?.dutchBucketPercent > 0) {
      iotUnit++;
    }
    if (allQData?.input_info?.growBagPercent > 0) {
      iotUnit++;
    }
    if (iotUnit > 1) {
      setIOTUnit(iotUnit);
    }
  }, [allQData]);
  let serial = 0;
  let serial2 = 0;
  let serial3 = 0;
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const elements = document.getElementsByClassName("gb-div");
        for (let element of elements) {
          element.innerHTML = element.innerHTML.replace(
            "GROW-BAG",
            "GROW-SLAB"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow bag",
            "Grow slab"
          );
          element.innerHTML = element.innerHTML.replace(
            "grow bags",
            "grow slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow bags",
            "Grow slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow Bags",
            "Grow Slabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "Grow Bag",
            "Grow Slab"
          );
          element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
          element.innerHTML = element.innerHTML.replace(
            "Growbags",
            "Growslabs"
          );
          element.innerHTML = element.innerHTML.replace(
            "growbags",
            "growslabs"
          );
        }
      }, 1000);
  }, [allQData]);
  const getAdditionalStatus = (arr1, arr2, arr3, system, name) => {
    if (system === "As Per Industry") {
      if (!arr1.includes(name)) return "(Additional)";
    } else if (system === "Kryzen Pro") {
      if (!arr2.includes(name)) return "(Additional)";
    } else if (system === "Kryzen Pro Max") {
      if (!arr3.includes(name)) return "(Additional)";
    } else if (!arr1.includes(name)) {
      return "(Additional)";
    } else {
      return "";
    }
  };
  return (
    <div className="gb-div">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: 0,
          padding: 0,
          borderBottom: "1px solid black",
          borderTop: "1px solid black",
        }}
      >
        <div>
          <p
            style={{
              margin: 0,
            }}
          >
            Business / Person name:
            {allQData?.input_info?.businessName ||
              allQData?.input_info?.contactPersonName}
            <br />
            Contact Person: {allQData?.input_info?.contactPersonName} <br />
            GSTIN: {allQData?.input_info?.gstNumber || "N/A"}
          </p>
        </div>
        <div>
          <p
            style={{
              margin: 0,
            }}
          >
            {/* Quotation for: {getQuotationFor()} <br /> */}
            Quotation number: <b>{allQData?.quotationNumber}</b> <br />
            Date: {allQData?.input_info?.quotationDate} <br />
            Address: {allQData?.input_info?.address} <br />
            {/* Country of supply: India <br /> */}
          </p>
        </div>
      </div>
      <p
        className="fw-bold mb-0"
        style={{
          textAlign: "center",
          fontSize: "1rem",
        }}
      >
        QUOTATION : ENGINEERING - PROCUREMENT - MANUFACTURING - COMMISSIONING
      </p>
      <p style={{ textAlign: "center", marginBottom: "10px" }}>
        <b>{getQuotationFor(allQData?.input_info)}</b>
      </p>
      {/* <p style={{ textAlign: "center", color: "green" }}>
        As Per “Development of Commercial Horticulture” of National Horticulture
        Board (NHB)
      </p> */}
      {allQData?.input_info?.kryzenProMax?.includes("cea_nvph_fp_nethouse") && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            controlled environment agriculture
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>

              {(allQData?.input_info?.quotationType === "nvph" ||
                allQData?.input_info?.quotationType === "soilbasednvph" ||
                allQData?.input_info?.quotationType ==
                  "nvph with hydroponics") && (
                <tr>
                  <td>{++serial}</td>
                  <td>
                    {allQData?.input_info?.quotationType === "soilbasednvph"
                      ? "Nvph Soil Based Precision Farming"
                      : "Naturally Ventilated Polyhouse Structure"}
                    <ul className="mb-0">
                      <li>
                        GI Pipe Structure: All GI Pipes of 2mm thickness and
                        300+GSM and Zinc Coated
                      </li>
                      <li> GI fittings for Complete Structure</li>
                      <li> Polyfilm Covering</li>
                      <li>Side Curtains</li>
                      <li> Apron, Insect Net</li>
                      <li> Agro Shade Nets</li>
                      <li> Gutter for Rain water Drainage</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}

              {(allQData?.input_info?.quotationType === "fanpad" ||
                allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                allQData?.input_info?.quotationType ==
                  "fanpad with hydroponics") && (
                <tr>
                  <td>{++serial}</td>
                  <td>
                    {allQData?.input_info?.quotationType === "soilbasedfanpad"
                      ? "Fan & Pad Soil Based Precision Farming"
                      : "Fan & Pad Polyhouse Structure"}

                    <ul className="mb-0">
                      <li> GI Pipe Structure</li>
                      <li>
                        All GI Pipes of 2mm thickness and 300+GSM and Zinc
                        Coated
                      </li>
                      <li> GI fittings for Complete Structure</li>
                      <li>
                        Polyfilm Covering with high thich material for air
                        blocking
                      </li>
                      <li>
                        {" "}
                        Cellulose pads of 4inch thickness to get air cooled.
                      </li>
                      <li> Aluminum exhaust fans to presure air extraction.</li>
                      <li> Apron, Insect Net</li>
                      <li> Agro Shade Nets</li>
                      <li> Gutter for Rain water Drainage</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}

              {(allQData?.input_info?.quotationType === "nethouse" ||
                allQData?.input_info?.quotationType === "soilbasednethouse" ||
                allQData?.input_info?.quotationType ==
                  "nethouse with hydroponics") && (
                <tr>
                  <td>{++serial}</td>
                  <td>
                    {allQData?.input_info?.quotationType === "soilbasednethouse"
                      ? "Net House Soil Based Precision Farming"
                      : " Net House Structure"}

                    <ul className="mb-0">
                      <li>GI Pipe Structure</li>
                      <li>
                        All GI Pipes of 2mm thickness and 300+GSM and Zinc
                        Coated
                      </li>
                      <li> GI fittings for Complete Structure</li>
                      <li>Apron, Insect Net</li>
                      <li>Agro Shade Nets</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "cea_nvph_fp_nethouse"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) => item.name === "cea_nvph_fp_nethouse"
                    )?.cost
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {allQData?.input_info?.kryzenProMax?.includes("hydroponic_system") && (
        <>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            HYDROPONIC FARM SYSTEM
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>

              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  {allQData?.input_info?.a_FramePercent > 0 && (
                    <>
                      <b>
                        ({allQData?.input_info?.a_FramePercent}%) A-Frame NFT
                        Hydroponic farm system
                      </b>
                      <ul>
                        <li>Double coated Mild Steel Metal frame.</li>
                        <li>Double layer, Food grade, Lead free NFT pipes.</li>
                        <li>
                          Double strengthened, injection molded end caps and
                          sprouts for additional reinforcement and capping on
                          both ends.
                        </li>
                        <li>
                          High Quality 0.5HP to 1HP pump (Based on design and
                          slope requirement) to ensure steady supply of water.
                        </li>
                        <li>
                          Reservoir tanks of 3 layers based on temprature of
                          surrounding.
                          {/* Defused tank to avoid inside allegie
                          and pathogen formation. */}
                        </li>
                        <li>
                          Centeralize plumbing system to ensure adequate water
                          delivery to all channels.
                        </li>
                        {/* <li> Net cups to support plants root zone.</li> */}
                        {/* <li>
                          Hydroton balls to provide access moisture support to
                          the plants.
                        </li>
                        <li>
                          Cocopeat or similar inert media for seed development.
                        </li> */}
                      </ul>
                    </>
                  )}
                  {allQData?.input_info?.flatBedPercent > 0 && (
                    <>
                      <b>
                        ({allQData?.input_info?.flatBedPercent}%) FlatBed NFT
                        Hydroponic farm system
                      </b>
                      <ul>
                        <li>Double coated Mild Steel Metal frame.</li>
                        <li>Double layer, Food grade, Lead free NFT pipes.</li>
                        <li>
                          Double strengthened, injection molded end caps and
                          sprouts for additional reinforcement and capping on
                          both ends.
                        </li>
                        <li>
                          High Quality 0.5HP to 1HP pump (Based on design and
                          slope requirement) to ensure steady supply of water.
                        </li>
                        <li>
                          Reservoir tanks of 3 layers based on temprature of
                          surrounding.
                          {/* Defused tank to avoid inside allegie
                          and pathogen formation. */}
                        </li>
                        <li>
                          Centeralize plumbing system to ensure adequate water
                          delivery to all channels.
                        </li>
                        {/* <li> Net cups to support plants root zone.</li> */}
                        {/* <li>
                          Hydroton balls to provide access moisture support to
                          the plants.
                        </li>
                        <li>
                          Cocopeat or similar inert media for seed development.
                        </li> */}
                      </ul>
                    </>
                  )}

                  {allQData?.input_info?.growBagPercent > 0 && (
                    <>
                      {allQData?.input_info?.isGrowSlab ? (
                        <>
                          <b>
                            ({allQData?.input_info?.growBagPercent}%) Growslab
                            Hydroponic farm system
                          </b>
                          <ul>
                            <li>
                              4 layerd, UV treated Food grade uPVC contaner
                              including lid with dranage mechanism and strong
                              base support with 100 cycles life.
                            </li>
                            <li>
                              {" "}
                              Hydroton balls with Netcups for plant support.
                            </li>
                            <li>
                              Multi-zone irrigation system with independent
                              plumbing.
                            </li>
                            <li>
                              High Quality 0.5HP to 1HP pump (Based on design
                              and slope requirement) to ensure study supply of
                              water.
                            </li>
                            <li>
                              Reservoir tanks of 3 layers based on temprature of
                              surrounding.
                              {/* Defused tank to avoid
                              inside allegie and pathogen formation. */}
                            </li>
                            <li>
                              Pressure Compresating Joint Nipple to contant
                              water flow.
                            </li>
                            <li>
                              Netafim arrow dripper to delivery of nutrient at
                              roots with minimal wastage.
                            </li>
                            <li>
                              {" "}
                              Drip irrigation plumbing for every channels.
                            </li>
                            {/* <li>
                              Cocopeat or similar inert media for seed
                              development.
                            </li> */}
                            <li>
                              Trellising Crop Support System. Made up of GI wire
                              rope and GI thread
                            </li>

                            <li>
                              Trellising Instalation (GI wire Rope, Monofilament
                              Wire, UV Treated Threads with Hooks)
                            </li>
                            <li>
                              Additional Plant clips to support winery plant
                              stem.
                            </li>
                          </ul>
                        </>
                      ) : (
                        <>
                          <b>
                            ({allQData?.input_info?.growBagPercent}%) Growbags
                            Hydroponic farm system
                          </b>
                          <ul>
                            <li>
                              Double layerd, UV treated grow bags with dranage
                              mechanism.
                            </li>
                            <li>
                              Low EC Cocopeat, De-stoned and washed,
                              decontaminated.
                            </li>
                            <li>
                              Multi-zone irrigation system with independent
                              plumbing.
                            </li>
                            <li>
                              High Quality 0.5HP to 1HP pump (Based on design
                              and slope requirement) to ensure study supply of
                              water.
                            </li>
                            <li>
                              Reservoir tanks of 3 layers based on temprature of
                              surrounding.
                              {/* Defused tank to avoid
                              inside allegie and pathogen formation. */}
                            </li>
                            <li>
                              Pressure Compresating Joint Nipple to contant
                              water flow.
                            </li>
                            <li>
                              Netafim arrow dripper to delivery of nutrient at
                              roots with minimal wastage.
                            </li>
                            <li>
                              {" "}
                              Drip irrigation plumbing for every channels.
                            </li>
                            {/* <li>
                              Cocopeat or similar inert media for seed
                              development. (Different then grow bags media)
                            </li> */}
                            <li>
                              Trellising Instalation (GI wire Rope, Monofilament
                              Wire, UV Treated Threads with Hooks)
                            </li>
                            <li>
                              Additional Plant clips to support winery plant
                              stem.
                            </li>
                          </ul>
                        </>
                      )}
                    </>
                  )}
                  {allQData?.input_info?.dutchBucketPercent > 0 && (
                    <>
                      <b>
                        ({allQData?.input_info?.dutchBucketPercent}%) Dutch
                        Bucket Hydroponic farm system
                      </b>
                      <ul className="m-0">
                        <li>
                          4 layerd, UV treated Food grade uPVC contaner
                          including lid with dranage mechanism and strong base
                          support with 100 cycles life.
                        </li>
                        <li> Hydroton balls with Netcups for plant support.</li>
                        <li>
                          Multi-zone irrigation system with independent
                          plumbing.
                        </li>
                        <li>
                          High Quality 0.5HP to 1HP pump (Based on design and
                          slope requirement) to ensure steady supply of water.
                        </li>
                        <li>
                          Reservoir tanks of 3 layers based on temprature of
                          surrounding. Defused tank to avoid inside allegie and
                          pathogen formation.
                        </li>
                        <li>
                          Pressure Compresating Joint Nipple to contant water
                          flow.
                        </li>
                        <li>
                          Netafim arrow dripper to delivery of nutrient at roots
                          with minimal wastage.
                        </li>
                        <li> Drip irrigation plumbing for every channels.</li>
                        {/* <li>
                          Cocopeat or similar inert media for seed development.
                        </li> */}
                        <li>
                          Trellising Crop Support System. Made up of GI wire
                          rope and GI thread
                        </li>
                        <li>
                          Trellising Instalation (GI wire Rope, Monofilament
                          Wire, UV Treated Threads with Hooks)
                        </li>
                        <li>
                          Additional Plant clips to support winery plant stem.
                        </li>
                      </ul>
                    </>
                  )}
                  <>
                    <b>Ground cover weedmat </b>
                    <ul>
                      <li>Black colored (Grade A 100GSM)</li>
                    </ul>
                  </>
                </td>

                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) => item.name === "hydroponic_system"
                    )?.cost / allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) => item.name === "hydroponic_system"
                    )?.cost
                  )}
                </td>
              </tr>

              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) => item.name === "hydroponic_system"
                    )?.cost
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      {allQData?.input_info?.kryzenProMax?.includes(
        "engineering_errection_commissioning"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Engineering, Errection & Commissioning
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  Entire structure planning, designing, manufacturing and
                  modifying
                  <ul className="m-0">
                    <li>
                      Entire structure planning, designing, manufacturing and
                      modifying
                    </li>
                    {allQData?.input_info?.quotationType !== "nvph" &&
                      allQData?.input_info?.quotationType !== "fanpad" &&
                      allQData?.input_info?.quotationType !== "nethouse" &&
                      allQData?.input_info?.quotationType !==
                        "soilbasedfanpad" &&
                      allQData?.input_info?.quotationType !== "soilbasednvph" &&
                      allQData?.input_info?.quotationType !==
                        "soilbasednethouse" && (
                        <li>
                          Based on site inspection data, your structure will be
                          designed for desired wind and climate protection.
                        </li>
                      )}
                    <li>
                      Project Design, Project Development, Project Management &
                      Consulting,
                    </li>
                    <li>
                      Procurement of raw material, loading and unloading of
                      material with QA and fitness certification.
                    </li>
                    <li>
                      Manufacturing of GI material, QC and QA of material with
                      tensile and thickness tests.
                    </li>
                    <li>Loading of material as per HSN standards.</li>
                    <li>
                      Transportation guidance and related Government
                      documentation.
                    </li>
                    <li>
                      Unloading of materials at site, with QA and Sagrigation.
                    </li>
                    <li> Labour assignment and errection of structure.</li>
                    <li> Site supervisor and Field engineer visits</li>
                    <li>
                      {" "}
                      Final QA{" "}
                      {allQData?.input_info?.quotationType !== "nvph" &&
                        allQData?.input_info?.quotationType !== "fanpad" &&
                        allQData?.input_info?.quotationType !== "nethouse" &&
                        allQData?.input_info?.quotationType ===
                          "soilbasedfanpad" &&
                        allQData?.input_info?.quotationType !==
                          "soilbasednvph" &&
                        allQData?.input_info?.quotationType !==
                          "soilbasednethouse" &&
                        `and Dry run of 3 days`}{" "}
                      before handover.
                    </li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) =>
                        item.name === "engineering_errection_commissioning"
                    )?.cost / allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) =>
                        item.name === "engineering_errection_commissioning"
                    )?.cost
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.input_info?.infrastructure?.find(
                      (item) =>
                        item.name === "engineering_errection_commissioning"
                    )?.cost
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* {allQData?.input_info?.kryzenProMax?.includes("growers_combo_sqm") && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Growers Combo{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "growers_combo_sqm"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li> Germination Trays</li>
                    <li> Fumigation Solution before starting of project.</li>
                    <li> Seeds</li>
                    <li> Nutrition First 30 days</li>
                    <li> Measuring Devices</li>
                    <li> Organic Neem Oil</li>
                    <li> Fungicide 250ml</li>
                    <li> All Shooter 100ml</li>
                    <li> pH up Concentrated Solution 2Ltr</li>
                    <li> pH Down Concentrated Solution 4Ltr</li>
                    <li> Insect sticky pad (1 Bundle)</li>
                    <li> pH Meter (1 Unit)</li>
                    <li> EC / TDS / Temprature Meter (1 Unit)</li>
                    KBPL does not holds any license or system to sell
                    fertilizers, seeds, pesticides, herbicides, growth boosters,
                    water tritement solutions and fumigation solutions. All
                    above particulars are made avilable via third party license
                    holding vendors.
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.growersCombo /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.growersCombo)}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.growersCombo)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
      {/* {allQData?.input_info?.kryzenProMax?.includes(
        "air_circulation_fan_8x4"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Air Circulation Fans{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "air_circulation_fan_8x4"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li> 4 Blade Stainless Steel ACFs </li>
                    <li> Rotating at 960 RPM with 63 CMH+ Airflow </li>
                    <li> Can push air up to 20 feets </li>
                    <li>
                      Concealed wiring and connection up to the Electric panel
                    </li>
                    <li> With manual and sensor-based control options </li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.totalBlocks8X4Mtr / 2} Units</td>
                <td>{roundOffCost(9000)}</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.airCirFanCost)}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.airCirFanCost)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {allQData?.input_info?.kryzenProMax?.includes(
        "fogger_system_netafim"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Foggers (Netafim) & Plumbing assembly{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "fogger_system_netafim"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li> Netafim Foggers with Anti-drain valve.</li>
                    <li> Fogger Plumbing assembly.</li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.foggerSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.foggerSystemCost
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.foggerSystemCost
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {allQData?.input_info?.kryzenProMax?.includes(
        "retractable_aluminum_net"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Retractable Aluminum Net{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "retractable_aluminum_net"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>
                      Retractable Aluminum (Aluminet Grade A) Net Helps control
                      temprature by additonal 5 degrees.
                    </li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.RetractableAluminumNet /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.RetractableAluminumNet
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.RetractableAluminumNet
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
      {/* removed */}
      {/* {allQData?.input_info?.kryzenProMax?.includes(
        "cyclic_periodic_timers"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Cyclic Periodic Timers{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "cyclic_periodic_timers"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>Cyclic Periodic Timer.</li>
                  </ul>
                </td>
                <td>1 Unit</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cyclic_periodic_timers
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cyclic_periodic_timers
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cyclic_periodic_timers
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
      {/* {allQData?.input_info?.kryzenProMax?.includes(
        "crop_support_system_growbags_dutchbucket"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Crop Support System{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "crop_support_system_growbags_dutchbucket"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>Trellising Crop Support System</li>
                    <li>Made up of GI wire rope and GI thread</li>
                  </ul>
                </td>

                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cropSupportSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cropSupportSystemCost
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cropSupportSystemCost
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
      {/* {allQData?.input_info?.kryzenProMax?.includes(
        "ground_cover_weedmat_grade_a_110gsm"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Ground cover weedmat{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "ground_cover_weedmat_grade_a_110gsm"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>Ground cover weedmat (Grade A 110GSM)</li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.GroundCoverWeedmatGrade /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.GroundCoverWeedmatGrade
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.GroundCoverWeedmatGrade
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
      {/* removed-end */}
      {/* {allQData?.input_info?.kryzenProMax?.includes("drip_system") && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Drip System
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "drip_system"
            ) && !allQData?.input_info?.selectedSystem}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>Drip System (ISI Marked)</li>
                  </ul>
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.dripSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.dripSystemCost)}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.dripSystemCost)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {allQData?.input_info?.kryzenProMax?.includes(
        "mechanical_geared_vent_operator"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            Mechanical geared vent opener{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "mechanical_geared_vent_operator"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li>Mechanical geared vent opener</li>
                  </ul>
                </td>
                <td>
                  {Math.ceil(
                    allQData?.quotationMatrixCost
                      ?.MechanicalGearedVentOperator / 10000
                  )}
                  Unit
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost
                      ?.MechanicalGearedVentOperator /
                      Math.ceil(
                        allQData?.quotationMatrixCost
                          ?.MechanicalGearedVentOperator / 10000
                      )
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.MechanicalGearedVentOperator
                  )}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.MechanicalGearedVentOperator
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {allQData?.input_info?.kryzenProMax?.includes(
        "iot_automation_screen_display"
      ) && (
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            IoT Automation & Screen Display{" "}
            {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "iot_automation_screen_display"
            )}
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              <tr>
                <td>{(serial = 1)}.</td>
                <td>
                  <ul className="m-0">
                    <li> IoT Automation & Screen Display</li>
                    <li>
                      Realtime Value gatheirng and Cloud push to
                      alpha.kryzen.com
                    </li>
                    <li>
                      IoT based Online Dashboard for Remote Monitoring and
                      Control
                    </li>
                  </ul>
                </td>

                <td>
                  {iotUnit} {iotUnit > 1 ? "Units" : "Unit"}
                </td>
                <td>{roundOffCost(155100)}</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.iotAndAutoCost)}
                </td>
              </tr>
              <tr className="fw-bold">
                <td></td>
                <td colSpan={3}>Total Cost</td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.iotAndAutoCost)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}

      {/* {allQData?.input_info?.kryzenProMax?.includes(
        "additional_handholding_support"
      ) && ( */}
      {allQData?.input_info?.quotationType !== "nvph" &&
        allQData?.input_info?.quotationType !== "fanpad" &&
        allQData?.input_info?.quotationType !== "nethouse" && (
          <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
            <p
              className="fw-bold mt-4 mb-0 text-uppercase"
              style={{
                fontSize: "1rem",
              }}
            >
              Handholding & Support
              {/* {getAdditionalStatus(
              allQData?.input_info?.asPerIndustry,
              allQData?.input_info?.kryzenPro,
              allQData?.input_info?.kryzenProMax,
              allQData?.input_info?.selectedSystem,
              "additional_handholding_support"
            )} */}
            </p>
            <table
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <th style={{ width: "4%" }}>Sr.</th>
                  <th style={{ width: "50%" }}>Particulars</th>
                  <th style={{ width: "9%" }}>Size/Unit</th>
                  <th style={{ width: "9%" }}>Rates</th>
                  <th style={{ width: "13%" }}>Amount</th>
                </tr>
                <tr>
                  <td>{(serial = 1)}.</td>
                  <td>
                    <ul className="m-0">
                      <li> Virtual agronomy (6 Month)</li>
                      <li> Hands-on labour training to KBPL's farm.</li>
                      <li>
                        Support of Call, Whatsapp, Video calls, Email and Chat
                        application
                      </li>
                      <li>
                        Agronomist will keep followup of software data & also
                        analyse farm operation
                      </li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(60000.0)}
                    <br />
                    Disc. : 100%
                  </td>

                  <td>{roundOffCost(0)}</td>
                </tr>
                <tr>
                  <td>{++serial}.</td>
                  <td>
                    <ul className="m-0">
                      <li> {`Buyers connect (Offer ${serial})`}</li>
                      <li>
                        Directly connect with community buyers where othjer
                        farmers are already swelling.
                      </li>
                      <li> Contract based farming for large size farms.</li>
                    </ul>
                  </td>

                  <td>1 User</td>
                  <td>
                    {roundOffCost(7999.0)} <br />
                    Disc. : 100%
                  </td>

                  <td>{roundOffCost(0)}</td>
                </tr>
                {/* <tr>
                <td>{++serial}.</td>
                <td>
                  <ul>
                    <li>Masterclass login (Offer 3)</li>
                  </ul>
                </td>

                <td>3 Users</td>
                <td>
                  {roundOffCost(2499.0)} <br />
                  Disc. : 100%
                </td>

                <td>{roundOffCost(0)}</td>
              </tr>
              <tr>
                <td>{++serial}.</td>
                <td>
                  <ul>
                    <li>NHB/NHM/AIF DPR (Offer 4)</li>
                  </ul>
                </td>

                <td>1 File</td>
                <td>
                  {roundOffCost(10000.0)} <br />
                  Disc. : 100%
                </td>

                <td>{roundOffCost(0)}</td>
              </tr> */}
                <tr>
                  <td>{++serial}.</td>
                  <td>
                    <ul className="mb-0">
                      <li>{`4 Days hands-on labour training (Offer ${serial})`}</li>
                      <li>
                        Labour will be equiped with all farm related operations.
                      </li>
                      <li> All plumbing and minor fixing work.</li>
                      <li> Nurserry Planning and Seed management.</li>
                      <li>
                        {" "}
                        Plant growing and fungus, pests and dieses management.
                      </li>
                      <li>
                        Harvest management, packaging and seller communication.
                      </li>
                      <li>
                        Cleaning of the system, and replantation of next batch.
                      </li>
                      <li>
                        {" "}
                        Waste management and organic fertilizer management.
                      </li>
                    </ul>
                  </td>

                  <td>2 Users</td>
                  <td>
                    {roundOffCost(20000.0)} <br />
                    Disc. : 100%
                  </td>
                  <td>{roundOffCost(0)}</td>
                </tr>
                <tr>
                  <td>{++serial}.</td>
                  <td>
                    <ul>
                      <li>{`Farm management software (Offer ${serial})`}</li>
                    </ul>
                  </td>
                  <td>1 Users</td>
                  <td>
                    {roundOffCost(20000.0)} <br />
                    Disc. : 100%
                  </td>

                  <td>{roundOffCost(0)}</td>
                </tr>
                <tr className="fw-bold">
                  <td></td>
                  <td colSpan={2}>Total Cost</td>
                  <td>
                    <strike> {roundOffCost(107999)}</strike> <br />
                  </td>
                  <td>{roundOffCost(0)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      {
        // (allQData?.input_info?.asPerIndustry?.includes(
        //   "air_circulation_fan_8x4"
        // ) ||
        //   allQData?.input_info?.asPerIndustry?.includes(
        //     "fogger_system_netafim"
        //   ) ||
        //   allQData?.input_info?.asPerIndustry?.includes(
        //     "retractable_aluminum_net"
        //   ) ||
        //   allQData?.input_info?.asPerIndustry?.includes("drip_system") ||
        //   allQData?.input_info?.asPerIndustry?.includes(
        //     "mechanical_geared_vent_operator"
        //   ) ||
        //   allQData?.input_info?.asPerIndustry?.includes(
        //     "iot_automation_screen_display"
        //   )) &&
        <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            ADDITIONAL TOPUPS
          </p>
          <table
            style={{
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "55%" }}>Particulars</th>
                <th style={{ width: "9%" }}>Size/Unit</th>
                <th style={{ width: "9%" }}>Rates</th>
                <th style={{ width: "13%" }}>Amount</th>
              </tr>
              {allQData?.input_info?.kryzenProMax?.includes(
                "air_circulation_fan_8x4"
              ) && (
                <tr>
                  <td>{++serial3}.</td>

                  <td>
                    <b>Air Circulation Fans</b>
                    <ul className="m-0">
                      <li> 4 Blade Stainless Steel ACFs </li>
                      <li> Rotating at 960 RPM with 63 CMH+ Airflow </li>
                      <li> Can push air up to 20 feets </li>
                      <li>
                        Concealed wiring and connection up to the Electric panel
                      </li>
                      <li> With manual and sensor-based control options </li>
                    </ul>
                  </td>

                  <td>{allQData?.area_in?.totalBlocks8X4Mtr / 2} Units</td>
                  <td>{roundOffCost(9000)}</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "air_circulation_fan_8x4"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "fogger_system_netafim"
              ) && (
                <tr>
                  <td>{++serial3}.</td>
                  <td>
                    <b>Foggers & Plumbing assembly</b>
                    <ul className="m-0">
                      <li> Netafim Foggers with Anti-drain valve.</li>
                      <li> Fogger Plumbing assembly.</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "fogger_system_netafim"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "fogger_system_netafim"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "retractable_aluminum_net"
              ) && (
                <tr>
                  <td>{++serial3}.</td>

                  <td>
                    <b>Retractable Aluminum Net</b>
                    <ul className="m-0">
                      <li>
                        Retractable Aluminum (Aluminet Grade A) Net Helps
                        control temprature by additonal 5 degrees.
                      </li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "retractable_aluminum_net"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "retractable_aluminum_net"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes("drip_system") && (
                <tr>
                  <td>{++serial3}.</td>

                  <td>
                    <b>Drip System</b>
                    <ul className="m-0">
                      <li>Drip System (ISI Marked)</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "drip_system"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "drip_system"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "mechanical_geared_vent_operator"
              ) && (
                <tr>
                  <td>{++serial3}.</td>

                  <td>
                    <b>Mechanical geared vent opener</b>
                    <ul className="m-0">
                      <li>Mechanical geared vent opener</li>
                    </ul>
                  </td>
                  <td>
                    {Math.ceil(
                      allQData?.input_info?.infrastructure?.find(
                        (item) =>
                          item.name === "mechanical_geared_vent_operator"
                      )?.cost / 10000
                    )}{" "}
                    Unit
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) =>
                          item.name === "mechanical_geared_vent_operator"
                      )?.cost /
                        Math.ceil(
                          allQData?.input_info?.infrastructure?.find(
                            (item) =>
                              item.name === "mechanical_geared_vent_operator"
                          )?.cost / 10000
                        )
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) =>
                          item.name === "mechanical_geared_vent_operator"
                      )?.cost || 0
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "iot_automation_screen_display"
              ) && (
                <tr>
                  <td>{++serial3}.</td>
                  <td>
                    <b>IoT Automation & Screen Display</b>
                    <ul className="m-0">
                      <li>
                        Realtime Value gatheirng and Cloud push to
                        alpha.kryzen.com
                      </li>
                      <li>
                        IoT based Online Dashboard for Remote Monitoring and
                        Control
                      </li>
                    </ul>
                  </td>

                  <td>
                    {iotUnit} {iotUnit > 1 ? "Units" : "Unit"}
                  </td>
                  <td>
                    {roundOffCost(
                      (allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "iot_automation_screen_display"
                      )?.cost || 0) / iotUnit || 0
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "iot_automation_screen_display"
                      )?.cost || 0
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "bed_preparation"
              ) && (
                <tr>
                  <td>{++serial3}.</td>
                  <td>
                    <b>Bed Preparation</b>
                    <ul className="m-0">
                      <li>Raised soil bed preparation and leveling.</li>
                      <li>Proper drainage and root-zone preparation.</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "bed_preparation"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "bed_preparation"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.input_info?.kryzenProMax?.includes(
                "mulching_sheet_installation"
              ) && (
                <tr>
                  <td>{++serial3}.</td>
                  <td>
                    <b>Mulching Sheet Installation</b>
                    <ul className="m-0">
                      <li>
                        Supply and installation of UV-stabilized mulch sheet.
                      </li>
                      <li>
                        Complete bed coverage for weed control and moisture
                        retention.
                      </li>
                    </ul>
                  </td>

                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "mulching_sheet_installation"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "mulching_sheet_installation"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}{" "}
              {allQData?.input_info?.kryzenProMax?.includes(
                "trellising_installation"
              ) && (
                <tr>
                  <td>{++serial3}.</td>
                  <td>
                    <b>Trellising Installation</b>
                    <ul className="m-0">
                      <li>GI wire, monofilament, threads, hooks and clips.</li>
                      <li>Complete installation for vertical crop support.</li>
                    </ul>
                  </td>
                  <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "trellising_installation"
                      )?.cost / allQData?.area_in?.area_in_sqmeter
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.input_info?.infrastructure?.find(
                        (item) => item.name === "trellising_installation"
                      )?.cost
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
      {/* )} */}
      {/*
      {allQData?.input_info?.retractableAluminumNet && (
              <tr>
                <td>{++serial}</td>
                <td>
                  Retractable Aluminum Net Helps control temprature
                  by additonal 5 degrees. Lifespan of 12 years. Aluminet Grade A
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.RetractableAluminumNet /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.RetractableAluminumNet
                  )}
                </td>
              </tr>
            )}
            {allQData?.input_info?.mechanicalGearedVentOpening && (
              <tr>
                <td>{++serial}</td>
                <td>Mechanical geared vent opener</td>
                <td>
                  {Math.ceil(
                    allQData?.quotationMatrixCost
                      ?.MechanicalGearedVentOperator / 10000
                  )}
                  Unit
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost
                      ?.MechanicalGearedVentOperator /
                      Math.ceil(
                        allQData?.quotationMatrixCost
                          ?.MechanicalGearedVentOperator / 10000
                      )
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.MechanicalGearedVentOperator
                  )}
                </td>
              </tr>
            )}
            {allQData?.input_info?.weedMat && (
              <tr>
                <td>{++serial}</td>
                <td>Ground cover weedmat (Grade A 110GSM)</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.GroundCoverWeedmatGrade /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.GroundCoverWeedmatGrade
                  )}
                </td>
              </tr>
            )}
            {allQData?.input_info?.dripSystem && (
              <tr>
                <td>{++serial}</td>
                <td>Drip System (Finolex Irrigation ISI Marked)</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.dripSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.dripSystemCost)}
                </td>
              </tr>
            )}
            {allQData?.input_info?.aircirculationFan && (
              <tr>
                <td>{++serial}</td>
                <td>
                  Air circultation Fans every 2 (8X4 block) will need 1 ACF
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.airCirFanCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.airCirFanCost)}
                </td>
              </tr>
            )}
            {allQData?.input_info?.foggerSystem && (
              <tr>
                <td>{++serial}</td>
                <td>Fogger System (Netafim)</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.foggerSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.foggerSystemCost
                  )}
                </td>
              </tr>
            )}
            {allQData?.input_info?.automation && (
              <tr>
                <td>{++serial}</td>
                <td>
                  IoT Automation & Display 
                </td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.iotAndAutoCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.iotAndAutoCost)}
                </td>
              </tr>
            )}
            {allQData?.input_info?.cropsupportSystem && (
              <tr>
                <td>{++serial}</td>
                <td>Crop Support System</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cropSupportSystemCost /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.cropSupportSystemCost
                  )}
                </td>
              </tr>
            )}
            {allQData?.input_info?.growersCombo && (
              <tr>
                {" "}
                <td>{++serial}</td>
                <td>Growers Combo per SqMtr</td>
                <td>{allQData?.area_in?.area_in_sqmeter} SqM</td>
                <td>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.growersCombo /
                      allQData?.area_in?.area_in_sqmeter
                  )}
                </td>
                <td>
                  {roundOffCost(allQData?.quotationMatrixCost?.growersCombo)}
                </td>
              </tr>
            )}
      */}
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <div
        style={{
          borderBottom: "1px solid black",
        }}
      >
        <KryzenTop />
      </div>

      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{ textAlign: "center", margin: 0, fontSize: "1.4rem" }}
      >
        Final Quotation
      </p>
      <p style={{ textAlign: "center", color: "green" }}>
        As Per “Development of Commercial Horticulture” of National Horticulture
        Board (NHB)
      </p>
      {/* {!allQData?.input_info?.selectedSystem && (
        <>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            CEA + Hydroponics : Fully Automated System
          </p>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "51%" }}>Particulars</th>
                <th style={{ width: "15%" }}>As per Industry</th>
                <th style={{ width: "15%" }}>Kryzen Pro</th>
                <th style={{ width: "15%" }}>Kryzen Pro Max</th>
              </tr>
              {allQData?.input_info?.infrastructure?.map((el, index) => {
                return (
                  <tr key={el.name}>
                    <td>{index + 1}</td>
                    <td>{el.value}</td>
                    <td>
                      {allQData?.input_info?.asPerIndustry?.includes(el.name)
                        ? roundOffCost(allQData?.quotationMatrixCost?.[el.name])
                        : "-"}
                    </td>
                    <td>
                      {allQData?.input_info?.kryzenPro?.includes(el.name)
                        ? roundOffCost(allQData?.quotationMatrixCost?.[el.name])
                        : "-"}
                    </td>
                    <td>
                      {allQData?.input_info?.kryzenProMax?.includes(el.name)
                        ? roundOffCost(allQData?.quotationMatrixCost?.[el.name])
                        : "-"}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td>{allQData?.input_info?.infrastructure?.length + 1}</td>
                <td>Handholding & Support</td>

                <td>{roundOffCost(0)}</td>
              </tr>
            </tbody>
          </table>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ width: "55%" }}>Amount</td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.asPerIndustryCost
                  )}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(allQData?.quotationMatrixCost?.kryzenProCost)}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.kryzenProMaxCost
                  )}
                </td>
              </tr>
              <tr>
                <td tyle={{ width: "55%" }}>GST</td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.asPerIndustryCost * 0.18
                  )}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.kryzenProCost * 0.18
                  )}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.kryzenProMaxCost * 0.18
                  )}
                </td>
              </tr>
              <tr>
                <td tyle={{ width: "55%" }}>Total</td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.asPerIndustryCost +
                      allQData?.quotationMatrixCost?.asPerIndustryCost * 0.18
                  )}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.kryzenProCost +
                      allQData?.quotationMatrixCost?.kryzenProCost * 0.18
                  )}
                </td>
                <td style={{ width: "15%" }}>
                  {roundOffCost(
                    allQData?.quotationMatrixCost?.kryzenProMaxCost +
                      allQData?.quotationMatrixCost?.kryzenProMaxCost * 0.18
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )} */}
      {allQData?.input_info?.selectedSystem === "As Per Industry" && (
        <>
          {/* <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            CEA + Hydroponics : Fully Automated System
          </p> */}
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={{ width: "4%" }}>Sr.</th>
                <th style={{ width: "45%" }}>Particulars</th>
                <th style={{ width: "10%" }}>Size/Unit</th>
                <th style={{ width: "10%" }}>Rates</th>
                <th style={{ width: "16%" }}>Generic Price</th>

                {/* <th style={{ width: "15%" }}>Kryzen Pro</th> */}
              </tr>
              {allQData?.input_info?.infrastructure?.map((el, index) => {
                if (allQData?.input_info?.asPerIndustry?.includes(el.name)) {
                  if (el.name === "cea_nvph_fp_nethouse") {
                    return (
                      <tr key={el.name}>
                        <td>{++serial2}</td>
                        <td>
                          {allQData?.input_info?.quotationType?.includes("nvph")
                            ? "CEA (NVPH)"
                            : allQData?.input_info?.quotationType?.includes(
                                "fanpad"
                              )
                            ? "CEA (Fanpad)"
                            : allQData?.input_info?.quotationType?.includes(
                                "nethouse"
                              )
                            ? "CEA (Nethouse)"
                            : ""}
                        </td>
                        <td>{el.unit ? `${el.unitValue} ${el.unit}` : "--"}</td>
                        <td>{el.rates ? roundOffCost(el.rates) : "--"}</td>
                        <td>
                          {allQData?.input_info?.asPerIndustry?.includes(
                            el.name
                          )
                            ? roundOffCost(el.cost)
                            : "-"}
                        </td>
                      </tr>
                    );
                  }
                  return (
                    <tr key={el.name}>
                      <td>{++serial2}</td>
                      <td>{el.value}</td>
                      <td>{el.unit ? `${el.unitValue} ${el.unit}` : "--"}</td>
                      <td>{el.rates ? roundOffCost(el.rates) : "--"}</td>
                      <td>
                        {allQData?.input_info?.asPerIndustry?.includes(el.name)
                          ? roundOffCost(el.cost)
                          : "-"}
                      </td>
                    </tr>
                  );
                }
              })}
              {/* hydroponicPlumbinCost, */}

              {allQData?.quotationMatrixCost?.consultingCost && (
                <tr>
                  <td>{++serial2}</td>
                  <td>Kryzen Biotech Consulting</td>
                  <td>--</td>
                  <td>--</td>
                  <td>
                    {roundOffCost(
                      allQData?.quotationMatrixCost?.consultingCost
                    )}
                  </td>
                </tr>
              )}
              {allQData?.quotationMatrixCost?.adminCost && (
                <tr>
                  <td>{++serial2}</td>
                  <td>Kryzen Biotech Admin Support</td>
                  <td>--</td>
                  <td>--</td>
                  <td>
                    {roundOffCost(allQData?.quotationMatrixCost?.adminCost)}
                  </td>
                </tr>
              )}

              {allQData?.input_info?.quotationType !== "nvph" &&
                allQData?.input_info?.quotationType !== "fanpad" &&
                allQData?.input_info?.quotationType !== "nethouse" &&
                allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                allQData?.input_info?.quotationType !== "soilbasednvph" &&
                allQData?.input_info?.quotationType !== "soilbasednethouse" && (
                  <tr>
                    <td>{++serial2}</td>
                    <td>Handholding & Support</td>
                    <td>--</td>
                    <td>--</td>
                    <td>{roundOffCost(0)}</td>
                  </tr>
                )}
            </tbody>
          </table>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ border: "none", width: "56%" }}>
                  <div style={{ paddingTop: "3px" }}>
                    {/* {hideScope == "CEA" && (
                      <>
                        <b>
                          SAVE EXTRA FLAT {roundOffCost(131798.0)} BY AVAILING
                          WITH LIMITED TIME OFFERS(Already applied).
                        </b>
                        <br />
                      </>
                    )} */}

                    <div
                      style={{
                        paddingBottom: "8px",
                        margin: "auto",
                        marginTop: "opx",
                      }}
                    >
                      In Words:{" "}
                      <b>
                        {convertRupeesToWords(
                          allQData?.quotationMatrixCost?.asPerIndustryCost +
                            allQData?.quotationMatrixCost?.asPerIndustryCost *
                              0.18
                        )}
                      </b>
                    </div>
                  </div>

                  {/* <% if record.currency.inr? %>
                      In Words:
                      <b><%= record.currency.format_value_in_words(record.calculator.total_amount_without_buyback_inc_gst) %></b>
                    <% end %> */}
                </td>
                <td
                  style={{
                    border: "none",
                    width: "44%",
                    paddingRight: "0px",
                    paddingLeft: "0px",
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {/* {allQData?.input_info?.maxDiscount > 0 && (
                                <>
                                  {" "}
                                  <tr>
                                    <td style={{ width: "50%" }}>Amount</td>
                                    <td style={{ width: "50%" }}>
                                      {roundOffCost(
                                        cost +
                                          cost * (allQData?.input_info?.maxDiscount / 100)
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: "50%" }}>Sales Discount</td>
                                    <td style={{ width: "50%" }}>
                                      {roundOffCost(allQData?.input_info?.maxDiscount)}%
                                    </td>
                                  </tr>
                                </>
                              )} */}
                      {allQData?.quotationMatrixCost?.discount > 0 && (
                        <tr>
                          <td style={{ width: "30%" }}>Total Amount</td>
                          <td style={{ width: "40%" }}>
                            {roundOffCost(
                              allQData?.quotationMatrixCost?.discount +
                                allQData?.quotationMatrixCost?.asPerIndustryCost
                            )}
                          </td>
                        </tr>
                      )}
                      {allQData?.quotationMatrixCost?.discount > 0 && (
                        <tr>
                          <td style={{ width: "30%" }}>Desc. Amount</td>
                          <td style={{ width: "40%" }}>
                            {roundOffCost(
                              allQData?.quotationMatrixCost?.discount
                            )}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td style={{ width: "30%" }}>
                          {allQData?.quotationMatrixCost?.discount
                            ? "Discounted Amount"
                            : "Amount"}
                        </td>
                        <td style={{ width: "40%" }}>
                          {roundOffCost(
                            allQData?.quotationMatrixCost?.asPerIndustryCost
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>GST 18%</td>
                        <td>
                          {roundOffCost(
                            allQData?.quotationMatrixCost?.asPerIndustryCost *
                              0.18
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>
                          {roundOffCost(
                            allQData?.quotationMatrixCost?.asPerIndustryCost +
                              allQData?.quotationMatrixCost?.asPerIndustryCost *
                                0.18
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default QuotationAmounts;
